import controller from './time-period.controller';

const template = require('./time-period.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/time-period.component.js